import { useQuery } from "convex/react";
import { api } from "convex/_generated/api";
import { useWorkspace } from "@/routes/$workspaceSlug/route";
import { PLAN_LIMITS } from "@/packages/domains/billing";

export function useBilling() {
  const { workspace } = useWorkspace();
  const subscription = useQuery(api.billing.queries.getWorkspaceSubscription, {
    workspaceId: workspace._id,
  });

  const tier = subscription?.tier ?? "professional";

  return {
    tier,
    subscription,
    entitlements: PLAN_LIMITS[tier],
    isLoading: subscription === undefined,
  };
}
